module.exports = __webpack_public_path__ + "img/logoTextMobily.fabf4add.svg";